var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8938 68.0376C53.6715 68.0376 68.8938 52.8153 68.8938 34.0376C68.8938 15.2599 53.6715 0.0375977 34.8938 0.0375977C16.1161 0.0375977 0.893799 15.2599 0.893799 34.0376C0.893799 52.8153 16.1161 68.0376 34.8938 68.0376ZM50.5067 25.4033C51.3713 24.2916 51.171 22.6895 50.0594 21.8249C48.9477 20.9602 47.3456 21.1605 46.481 22.2722L32.8572 39.7885C32.5542 40.178 31.9844 40.2285 31.6176 39.8984L22.9997 32.1423C21.9529 31.2002 20.3405 31.2851 19.3984 32.3319C18.4563 33.3787 18.5412 34.991 19.588 35.9331L28.2059 43.6892C30.7733 45.9999 34.7622 45.6461 36.8829 42.9196L50.5067 25.4033Z",
    fill: "#00D2A3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Success.ac039da3dcfde9fba6e68f4bc0b60ce8.svg";